export enum PolicyDomains {
  MOTOR = 'MOTOR',
  SHUR = 'SHUR'
}
